import { lazy } from "react";

const TournamentPage = lazy(() => import("./ui/TournamentPage/TournamentPage"));

export { TournamentPage };
